import script from "./HighlightedMelatiBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./HighlightedMelatiBlock.vue?vue&type=script&lang=ts&setup=true"

import "./HighlightedMelatiBlock.vue?vue&type=style&index=0&id=a9e3670a&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9e3670a"]])

export default __exports__